import { render, staticRenderFns } from "./BaseFormGroup.vue?vue&type=template&id=a038b882&scoped=true&"
import script from "./BaseFormGroup.vue?vue&type=script&lang=js&"
export * from "./BaseFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormGroup.vue?vue&type=style&index=0&id=a038b882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a038b882",
  null
  
)

export default component.exports